import { useTranslation } from 'react-i18next'
import Result from './Result'
import ResultColor from './ResultColor.enum'

interface ServerErrorProps {
  status?: number
}

const ServerError = (props: ServerErrorProps) => {
  const { status = 500 } = props
  const { t } = useTranslation()

  return (
    <Result
      status={status}
      title={t('error.500.title')}
      // subTitle={t('500 error')}
      description={t('error.500.description')}
      variant={ResultColor.Pink}
    />
  )
}

export default ServerError
